import React, { useContext } from 'react'
import { PERMISSIONS } from '@Const/permissions'
import { NavLink, useLocation } from 'react-router'
import Navigation from '@App/navigation'
import { ICONS } from '@Const/common'
import { StoresContext } from '@App/contexts'
import clsx from 'clsx'
import PermissionCheck from '@Components/Utility/PermissionCheck'
import { observer } from 'mobx-react'
import ExpandableItem from '../../Sidebar/ExpandableItem'

const MemberSettingsSubNavigation = () => {
    const { rightsholderStore, rightsholderUserStore, userStore } = useContext(StoresContext)
    const currentRightsholderId = rightsholderStore.currentRightsholderId
    const location = useLocation()

    const hasManageContactPermission = rightsholderUserStore.doesRHUserHavePermissionOrIsInternal(
        PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_contact_and_address
    )
    const hasManageBankingPermission = rightsholderUserStore.doesRHUserHavePermissionOrIsInternal(
        PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_banking_and_tax
    )

    return (
        <ExpandableItem heading="Member Settings" icon={ICONS.settings}>
            {hasManageBankingPermission && !userStore.isInternal && (
                <NavLink
                    className={(isActive) => clsx(isActive && '#banking-and-tax' === location.hash && 'active')}
                    to={Navigation.rightholder.maintenance.bankingAndTax(currentRightsholderId)}
                >
                    Banking Information
                </NavLink>
            )}
            {(hasManageContactPermission || hasManageBankingPermission) &&
                (!rightsholderStore.isRestricted || userStore.isInternal) && (
                    <NavLink
                        className={(isActive) => clsx(isActive && '#mailing-and-contact' === location.hash && 'active')}
                        to={Navigation.rightholder.maintenance.root(currentRightsholderId)}
                    >
                        Member Information
                    </NavLink>
                )}

            <PermissionCheck
                requiredPermissions={[PERMISSIONS.SUPER_USER_PERMISSIONS.manage_user_permissions]}
                orIsInternal
            >
                <NavLink to={Navigation.rightholder.maintenance.userPermissions(currentRightsholderId)}>
                    User Permissions
                </NavLink>
            </PermissionCheck>
            {hasManageContactPermission && (!rightsholderStore.isRestricted || userStore.isInternal) && (
                <NavLink to={Navigation.rightholder.maintenance.memberContacts(currentRightsholderId)}>
                    Contact Information
                </NavLink>
            )}
            {(!rightsholderStore.isRestricted || userStore.isInternal) && (
                <NavLink to={Navigation.rightholder.benefits(currentRightsholderId)}>Member Benefits</NavLink>
            )}
        </ExpandableItem>
    )
}

export default observer(MemberSettingsSubNavigation)
